import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-document-rdv',
  templateUrl: './document-rdv.component.html',
  styleUrls: ['./document-rdv.component.css']
})
export class DocumentRdvComponent implements OnInit {

  @Input() row;
  @Input() depuisPlanning;
  @Input() type;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  filename = '';
  i = 0;
  loadingIndicator: Boolean = false;
  deleteElm = [];
  data = []
  error = '';
  clickFermer: Boolean = false;

  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.clickFermer = false;
    this.type = this.type || (this.common.typeDoc !== '' ? this.common.typeDoc : this.type);

    this.getListDocument(this.row.id).then(() => {
    });
  }

  async getListDocument(id) {
    this.loadingIndicator = true;
    this.data = [];
    const param = {
      'servlet': 'DBGestionDocDeplComm',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': '4'
        },
        'CLEF_DEPLACEMENT': {
          'typeParam': 'int',
          'valeur': id
        }
      }
    };
    

    await this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.loadingIndicator = false
        this.data = [...datas.data];
      }
    });
  }

  addLigne() {
    this.data.push({});
    this.data = [...this.data];
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.data.filter(elt => elt !== row);
    this.data = temp;
  }

  close() {
    this.hidefunction.emit();
  }

  valide() {
    this.clickFermer = true;
    this.saveDoc();
  }

  getNameFile(event, item) {
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msg);    
      this.deleteLigne(item);
      return;
    }                    
    
    item.nomFichier = file.name;
    const fileReader = new FileReader();
    const ctrl = this;
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      item.contentBase64 = base64[1];
    };
    fileReader.readAsDataURL(file);
  }

  openDoc(row) {
    const param = {
      'servlet': 'DBImprimerDocumentsRapport',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Ecocrm/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_DOC_RAPPORT': {
          'typeParam': 'int',
          'valeur': row.id
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  openFile(url) {
    this.common.openFile(url);
  }


  onActivate(event) {
    if (event.type === 'dblclick') {
      if (event.row.id !== 0) {
        this.openDoc(event.row);
      }
    }
  }



  saveDoc() {
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.deleteDoc(elt);
          prom.push(fct);
      });
    }
    const add = this.data.filter(elt => !elt.id);
    console.log(add);
    if(add.length) {
       const sansDescrption = this.data.filter(elt => !elt.description);
       const sansnomFichier = this.data.filter(elt => !elt.nomFichier);
       if(sansDescrption.length) {
        this.clickFermer = false;
        this.error = "La descripiton  ne peut pas être vide"
        this.common.openModal(this.modalService, this.msg);
          return false
       }
       if(sansnomFichier.length) {
        this.clickFermer = false;
        this.error = "Veuillez choisir un fichier PDF"
        this.common.openModal(this.modalService, this.msg);
          return false
       }
    }

    if (add.length) {
      add.forEach(elt => {
        elt.id = 0;
        const fct = this.addDoc(elt);
        prom.push(fct);
      });
    }

    if (prom.length) {
      Promise.all(prom).then(data => {
        if (data.length) {
          this.validefunction.emit(this.row);
        }
        this.common.closeModal();

      }).catch(error => {
        this.common.closeModal();
        this.error = error;
        this.common.openModal(this.modalService, this.msg);
      });
    } else {
      this.validefunction.emit(this.row);
      this.common.closeModal();
    }
  }

  addDoc(doc) {
    doc['clefObjetParent'] = this.row ? this.row['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocDeplComm',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  deleteDoc(doc) {
    doc['clefObjetParent'] = this.row ? this.row['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocDeplComm',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

}